import React, { useEffect, useState } from 'react';
import './PWAUpdatePrompt.css';

interface PWAUpdatePromptProps {
  onUpdate: () => void;
  onClose: () => void;
  show: boolean;
}

const PWAUpdatePrompt: React.FC<PWAUpdatePromptProps> = ({ onUpdate, onClose, show }) => {
  if (!show) return null;

  return (
    <div className="pwa-update-overlay">
      <div className="pwa-update-modal">
        <div className="pwa-update-header">
          <h3>Cập nhật mới có sẵn</h3>
        </div>
        <div className="pwa-update-content">
          <p>Có phiên bản mới của ứng dụng KILOBA Hub. Bạn có muốn cập nhật ngay không?</p>
        </div>
        <div className="pwa-update-actions">
          <button className="pwa-update-btn pwa-update-btn-secondary" onClick={onClose}>
            Để sau
          </button>
          <button className="pwa-update-btn pwa-update-btn-primary" onClick={onUpdate}>
            Cập nhật ngay
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAUpdatePrompt;
